module.exports = __webpack_public_path__ + "static/media/beauty-is-our-business-model.4edf8eeb.png";